/* Dropdayz — ambient motion, site-wide.

   v7: .ddz-tg__cell toegevoegd aan REVEAL_SELECTORS — de vier belofte-vakjes
   onderaan de homepage (met de hand gecontroleerd / Klarna / 14 dagen retour /
   gratis verzending). Die verschenen alle vier tegelijk, waardoor het oog ze
   als één grijs blok las en doorscrolde. Nu schuiven ze 90 ms na elkaar in,
   samen ruim een halve seconde.

   LET OP het verband met v4 hieronder: toen is de onthulling van HELE secties
   op de homepage weggehaald omdat het "te langzaam" voelde. Dit is iets
   anders — vier kleine vakjes binnen één sectie, niet de sectie zelf. Voelt
   het alsnog traag, haal dan alleen '.ddz-tg__cell' uit de lijst hieronder.

   v6: onderaan dit bestand staat een TWEEDE blok — de bevestiging bij
   snel-toevoegen (de maatpil die naar het winkelwagen-icoon vliegt). Bewust
   hier en niet in een eigen bestand: dit script wordt al op elke pagina
   ingeladen, dus dat scheelt een regel in theme.liquid en een extra verzoek.
   Let op dat het een APART blok is: het blok hieronder stopt namelijk meteen
   als er niets te onthullen valt, en dat gebeurt op collectiepagina's.

   v5: added a SAFETY NET. The reveal states hide 20-30 blocks per
   editorial page until the IntersectionObserver fires. If that callback
   never runs -- throttled tab, an extension, a browser quirk -- the page
   stays blank, which is a far worse failure than a missing animation. Two
   timers now guarantee it cannot happen: at 1.8s everything at or above
   the fold is revealed, and at 6s everything left is revealed and the
   observer is disconnected. Never remove these.

   v4: homepage whole-section reveal REMOVED on owner feedback ("te
   langzaam, lijkt wel lag") -- sections on the index page render instantly
   again. Everything else stays: editorial-page reveals (.ddz-auth family),
   collection-hero entrance with clip-path mask on the title, count-up on
   the live collection-hero stats, badge pops and hover micro-interactions
   (those live purely in CSS).

   Progressive enhancement rules unchanged:
   - Without JS nothing is ever hidden (hide-states live under
     html.ddz-motion, which only this script adds).
   - prefers-reduced-motion or no IntersectionObserver: script exits first.
   - Snap-hide: the page paints before this deferred script runs, so each
     element's transition is suppressed for one frame while the hidden state
     applies -- hide is instant, only the reveal animates.
   - Count-ups capture the exact rendered string and restore it verbatim at
     the end, so a wrong number can never be left on screen. */
(function () {
  if (!('IntersectionObserver' in window)) { return; }
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

  var REVEAL_SELECTORS = [
    '.ddz-auth__herostat',
    '.ddz-auth__stat',
    '.ddz-auth__check',
    '.ddz-auth__col',
    '.ddz-auth__step',
    '.ddz-auth__flowstep',
    '.ddz-auth__tl-item',
    '.ddz-auth__faqgroup',
    '.ddz-auth__guarantee',
    '.ddz-auth__head',
    '.ddz-auth__note',
    '.ddz-auth__hero .ddz-auth__eyebrow',
    '.ddz-auth__hero .ddz-auth__display',
    '.ddz-auth__hero .ddz-auth__lede',
    '.ddz-coll-hero__eyebrow',
    '.ddz-coll-hero__title',
    '.ddz-coll-hero__tagline',
    '.ddz-coll-hero__stats',
    '.ddz-tg__cell'
  ].join(',');

  var MASK_SELECTORS = '.ddz-auth__hero .ddz-auth__display, .ddz-coll-hero__title';

  var els = Array.prototype.slice.call(document.querySelectorAll(REVEAL_SELECTORS));
  var timelines = Array.prototype.slice.call(document.querySelectorAll('.ddz-auth__timeline'));
  if (!els.length && !timelines.length) { return; }

  document.documentElement.classList.add('ddz-motion');

  els.forEach(function (el) {
    el.style.transition = 'none';
    el.classList.add('ddz-rv');
    if (el.matches && el.matches(MASK_SELECTORS)) { el.classList.add('ddz-mask'); }
    var siblings = Array.prototype.filter.call(el.parentNode.children, function (c) {
      return c.classList && c.classList.contains('ddz-rv');
    });
    var idx = siblings.indexOf(el);
    el.style.setProperty('--ddz-rv-delay', (idx > 0 ? idx * 90 : 0) + 'ms');
  });

  void document.body.offsetWidth;
  requestAnimationFrame(function () {
    els.forEach(function (el) { el.style.transition = ''; });
  });

  /* ---- count-up for the live collection-hero stats ---- */
  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }
  function countHeroStats(statsEl){
    if (statsEl.dataset.ddzCounted) { return; }
    statsEl.dataset.ddzCounted = '1';
    var nums = Array.prototype.slice.call(statsEl.querySelectorAll('.ddz-coll-hero__stat-num'));
    nums.forEach(function (el, i) {
      var finalText = el.textContent.trim();
      var m = finalText.match(/^(\d+)(x?)$/);
      if (!m) { return; }
      var target = parseInt(m[1], 10);
      var suffix = m[2] || '';
      var start = null;
      var DUR = 1300;
      function frame(ts){
        if (start === null) { start = ts; }
        var t = Math.min((ts - start) / DUR, 1);
        el.textContent = Math.round(target * easeOutCubic(t)) + suffix;
        if (t < 1) { requestAnimationFrame(frame); }
        else { el.textContent = finalText; }
      }
      setTimeout(function(){ requestAnimationFrame(frame); }, i * 150);
    });
  }

  function reveal(el){
    if (el.classList.contains('is-in')) { return; }
    el.classList.add('is-in');
    if (el.classList.contains('ddz-coll-hero__stats')) { countHeroStats(el); }
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) { return; }
      reveal(e.target);
      io.unobserve(e.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

  var watched = els.concat(timelines);
  watched.forEach(function (el) { io.observe(el); });

  /* ---- safety net: content must never stay invisible ---- */
  setTimeout(function () {
    watched.forEach(function (el) {
      if (el.classList.contains('is-in')) { return; }
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { reveal(el); io.unobserve(el); }
    });
  }, 1800);

  setTimeout(function () {
    watched.forEach(reveal);
    io.disconnect();
  }, 6000);
})();

/* ============================================================
   BEVESTIGING BIJ SNEL-TOEVOEGEN — 19 aug 2026

   Op de productkaarten kun je een maat aanklikken en dan zit het paar meteen
   in je winkelwagen. Maar als de lade niet direct opengaat, ziet niemand dat
   het gelukt is, en klikt hij nog een keer. De aangeklikte maatpil maakt nu
   een kopie van zichzelf die naar het winkelwagen-icoon vliegt, waarna het
   telletje even opspringt. Samen een halve seconde.

   Dit is puur bevestiging: gaat er iets mis, dan gebeurt er niets en werkt
   toevoegen gewoon. Bij "verminder beweging" slaat hij zichzelf over.
   ============================================================ */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
  if (!document.body || typeof document.body.animate !== 'function') { return; }

  var DOELEN = '.site-header__cart, .site-header__icons a[href*="/cart"], a[href$="/cart"]';

  function zoekDoel() {
    var kop = document.querySelector('.site-header');
    return (kop && kop.querySelector(DOELEN)) || document.querySelector(DOELEN);
  }

  function stuiterTeller() {
    var teller = document.querySelector('.site-header__cart-count');
    if (!teller || typeof teller.animate !== 'function') { return; }
    teller.animate([
      { transform: 'scale(1)' },
      { transform: 'scale(1.55)' },
      { transform: 'scale(1)' }
    ], { duration: 380, easing: 'cubic-bezier(.3,1.6,.4,1)' });
  }

  function laatVliegen(pil) {
    var doel = zoekDoel();
    if (!doel) { return; }
    var van = pil.getBoundingClientRect();
    var naar = doel.getBoundingClientRect();
    if (!van.width || !naar.width) { return; }

    var kopie = pil.cloneNode(true);
    kopie.setAttribute('aria-hidden', 'true');
    kopie.removeAttribute('id');
    var s = kopie.style;
    s.position = 'fixed';
    s.left = van.left + 'px';
    s.top = van.top + 'px';
    s.width = van.width + 'px';
    s.height = van.height + 'px';
    s.margin = '0';
    s.zIndex = '99999';
    s.pointerEvents = 'none';
    s.display = 'flex';
    s.alignItems = 'center';
    s.justifyContent = 'center';
    document.body.appendChild(kopie);

    var dx = (naar.left + naar.width / 2) - (van.left + van.width / 2);
    var dy = (naar.top + naar.height / 2) - (van.top + van.height / 2);

    var beweging = kopie.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.55) + 'px,' + (dy * 0.42 - 40) + 'px) scale(.8)', opacity: 0.95, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.28)', opacity: 0 }
    ], { duration: 520, easing: 'cubic-bezier(.45,-.15,.35,1)' });

    beweging.onfinish = function () {
      if (kopie.parentNode) { kopie.parentNode.removeChild(kopie); }
      stuiterTeller();
    };
    setTimeout(function () {
      if (kopie.parentNode) { kopie.parentNode.removeChild(kopie); }
    }, 1600);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var pil = t.closest('[data-ddz-qa-size]');
    if (!pil) { return; }
    laatVliegen(pil);
  }, true);
})();
